var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 438.63 329.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2,.cls-3{fill:#ddecff;}.cls-10,.cls-19,.cls-3{mix-blend-mode:multiply;}.cls-4{fill:#5793ce;}.cls-5{fill:#223a7a;}.cls-25,.cls-6{fill:#fff;}.cls-7{fill:#1c83ff;}.cls-8{fill:#ff9d8c;}.cls-9{fill:#8593b6;}.cls-11{fill:#8e9bbb;}.cls-12{fill:#dee1eb;}.cls-13{fill:#818fb3;}.cls-14{fill:#43588e;}.cls-15{fill:#f6f7fa;}.cls-16{fill:#d9dee8;}.cls-17{fill:#596b9b;}.cls-18{fill:#7a89af;}.cls-19{fill:#bdc4d7;}.cls-20{fill:#6f7fa9;}.cls-21{fill:#9ca6c3;}.cls-22{fill:#699dd1;}.cls-23{fill:#d2e6ff;}.cls-24{fill:#ff5f42;}.cls-25{font-size:12px;font-family:Quicksand-Bold, Quicksand Bold;font-weight:700;}.cls-26{fill:#67acff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.46,384.26s-54.62-38.89-70.34-105.1,8.27-146.48,53.79-187,127.45-13.24,163.86,20.69l36.42,33.93s34.76,19,80.27,17.38,86.07,60.42,96.83,109.25-14.9,113.37-14.9,113.37Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82.64,394.19s-38.07-20.69-48-68.69,33.1-91.86,37.24-115.86-5-53.79,33.1-77S210.91,117.78,236.57,112,292,66.47,343.33,75.57s101,36.42,103.44,96-16.55,61.24,2.49,93.52,26.48,54.62,17.38,87.72S438.5,395,438.5,395Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M162.12,383.43c-2.36-2.48-37.1-72,1.58-135.72s135.78-56.28,174.45-31.45,57.63,57.11,61.58,91-22.11,86.89-22.11,86.89Z",
    transform: "translate(-32.3 -71.85)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 352.54,
    y: 162.27,
    width: 54.62,
    height: 32.28,
    rx: 5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "379.85 207.17 386.93 190.41 372.78 190.41 379.85 207.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "379.69 172.87 392.46 172.87 392.46 174.74 398.72 171.13 392.46 167.51 392.46 169.38 379.69 169.38 379.69 172.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "398.72 180.21 385.95 180.21 385.95 178.34 379.69 181.95 385.95 185.56 385.95 183.69 398.72 183.69 398.72 180.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M404.14,255.35l-.6.22a19.1,19.1,0,0,1-2.88-4.52,16.06,16.06,0,0,1-1-5.23l.44-.19-2.7-6.46a5.29,5.29,0,0,0-1.31,1.48c-1.53,2.59-1.38,6.55.16,10.42s3.18,7.33,6.18,9.5a5.93,5.93,0,0,0,4.47,1.32Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M406.08,254.59l-.84.3,2.77,6.62a4.93,4.93,0,0,0,.83-.36,1.61,1.61,0,0,0,.73-2l-1.44-3.63A1.61,1.61,0,0,0,406.08,254.59Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M399.49,238a6.94,6.94,0,0,0-1.08.51l2.76,6.6.93-.38a1.63,1.63,0,0,0,.88-2.07L401.53,239A1.62,1.62,0,0,0,399.49,238Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M149.22,372.26V297.78s-.83-20.07,9.73-25.86,55-2.69,55-2.69v103Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M227.88,199.5s-2.69,22.56-3.73,24.42l-1,1.86L218,229.3s9.93,14.07,22.13,16.34,11.18-5,11.18-5l-1.87-3.94,2.49-21.51S229.74,205.09,227.88,199.5Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M211.53,231.16l8.07-3.52s5.17,8.48,17.17,13.45,12.21,2.07,12.83,0a7.88,7.88,0,0,0-.21-4.35l.89-7.24,4.8,1.6,16.66,134.75-42.83,2.07Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M251.05,229.64s2.9,6.69,5.59,22.42,5.17,42.2,5.79,60.41,1,59.79,1,59.79h54c.62,0,4.35-20.48,4.35-20.48S298.22,331.57,297,328.26c-.83-2.2-.41-43.1-3.93-61.93S285,243.71,275.46,239C265.63,234.17,251.05,229.64,251.05,229.64Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M279.19,348.56a.5.5,0,0,1-.5-.5c0-1.48-.27-22.5-.52-42.83s-.52-41.34-.52-42.83a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5c0,1.48.27,22.5.52,42.82s.52,41.35.52,42.84A.51.51,0,0,1,279.19,348.56Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M171.6,343.5l-.41,28.76h62.89s2.69-24.41,1.66-26.69S171.6,343.5,171.6,343.5Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M241.6,223.3a32.93,32.93,0,0,0,8.8,4.72l1.48-12.79s-16.63-7.62-22.27-13.29C230.79,208.38,233.69,216.91,241.6,223.3Z",
    transform: "translate(-32.3 -71.85)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M271.33,157.5a44.87,44.87,0,0,1,5.17,16.56c.83,9.1,0,32.48-7.45,42.41s-23,7-30,1c-6.46-5.5-12.83-11.58-14.48-23.58s3.51-34.76,18.2-39.52S271.33,157.5,271.33,157.5Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M290,359.26s-.73,0-1.84,0h-.85l-3.68-.1-.88,0c-1.3,0-2.41.13-3.45.07h0c-.22,0-.54,0-.8,0a1.94,1.94,0,0,1-.33,0,4.86,4.86,0,0,1-1.37-.54,93,93,0,0,0-21.46-2.86c-9.24,0-17.53.67-18.88-.46s-2.18-12.76,5.71-13.52l9.7,3.68s22.15-2.63,30.27,3.36S290,359.26,290,359.26Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M279.26,359.16c-.22,0-.54,0-.8,0a9.39,9.39,0,0,0-.85-1.14c-2.5-2.55-8.54-4.2-10.73-4.73a.38.38,0,0,1-.28-.45.38.38,0,0,1,.46-.28c3.19.77,10,2.74,11.88,6C279,358.65,279.16,359,279.26,359.16Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M283.62,359.11c-.29,0-.59,0-.88,0-2.73-5-7.19-6.4-12.71-8.18l-.33-.11a.37.37,0,1,1,.24-.71l.32.11C276.09,352.06,280.79,353.56,283.62,359.11Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M288.15,359.22h-.85a21.79,21.79,0,0,0-14.38-10.66.37.37,0,0,1-.31-.44.39.39,0,0,1,.43-.3C280.51,349.22,286.54,355.31,288.15,359.22Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M229.53,183.68a19.44,19.44,0,0,0,7.76-8.28,23.48,23.48,0,0,0,2.79-11.59s5.8-.93,14.49,1.66,19,6.1,27.72,1.14,8.69-12.93,4.45-16.24c-4.75-3.71-14.17-1.45-14.17-1.45s3.62-3.52,1.65-5.59-9.1.62-9.1.62-8.69-6.93-25.14-6.1S215.67,150.16,214.74,163s3.72,25.65,3.72,25.65Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M262.9,186.79c-.93,2.29-.91,5-1.14,7.4-.18,1.9-.53,4.11,1.21,5.39.83.61,4.75,2.26,2.73,3.6a5.3,5.3,0,0,1-2.93.33c-.61,0-1.22,0-1.82-.1s-1.29-.24-1.93-.25a.38.38,0,0,0-.19.7,8,8,0,0,0,3.79.9,5.65,5.65,0,0,0,3.14-.55,2.27,2.27,0,0,0,1.44-1.61,2.56,2.56,0,0,0-1.24-2.21c-.78-.58-1.74-.85-2.53-1.42-1.1-.78-1-2.1-.93-3.33.18-2.94.86-5.83,1.12-8.76,0-.44-.58-.44-.72-.09Z",
    transform: "translate(-32.3 -71.85)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M271.36,193.66c-.31,1.75-1.58,3-2.83,2.76s-2-1.82-1.72-3.56,1.58-3,2.83-2.76S271.67,191.92,271.36,193.66Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M255.53,192.28c-.28,1.88-1.61,3.25-3,3s-2.23-1.89-1.95-3.77,1.61-3.24,3-3S255.81,190.4,255.53,192.28Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M267.67,186.48c1,.16,1.95,0,2.92.06l.7.07h-.08l.15,0,.37.07c.2.05.4.13.61.18a3,3,0,0,0,.59.08l.32-.05-.2,0a3.37,3.37,0,0,0,.4,0,1.09,1.09,0,0,0,.74-1.31,1.19,1.19,0,0,0-.21-.42c0-.06-.09-.11-.13-.16l.12.13-.13-.17a.66.66,0,0,0-.22-.22l-.24-.18a2.78,2.78,0,0,0-.89-.36,7.69,7.69,0,0,0-1.78-.23,12.92,12.92,0,0,0-1.76.14,3.38,3.38,0,0,0-1.51.56,1,1,0,0,0-.47,1,1,1,0,0,0,.7.82Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M256.64,183.71a3.17,3.17,0,0,0-.41-.21c-.11-.05-.43-.22-.19-.09l-.27-.14a6,6,0,0,0-1.25-.45,8.32,8.32,0,0,0-2.9-.2,6.71,6.71,0,0,0-2.87.9,1.9,1.9,0,0,0-.37.26l-.2.27,0-.09a1,1,0,0,0-.43.84.85.85,0,0,0,.45.75,1.29,1.29,0,0,0,1,0h-.52a1.86,1.86,0,0,0,.78,0s.28-.07.1,0,.28,0,.33,0,.37,0,0,0l.18,0,.47-.05c.68,0,1.36-.08,2.05-.1s1.28,0,1.92,0l.81,0c.15,0,.09,0,0,0l.17,0,.34.11a1,1,0,0,0,1.13-.55,1,1,0,0,0-.39-1.2Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M261.55,212.47a9.38,9.38,0,0,1,4.67-4.21c-1.73-.18-9.91-.93-12,.24-2.31,1.31.43,6.59,5.21,6.85a6.32,6.32,0,0,0,1.4-.08A6.93,6.93,0,0,1,261.55,212.47Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M223.74,201.37s.83,3.2,5.59,6.93A55,55,0,0,0,241,214.74l.55-2.41s-7.14-3.1-10.45-6.52-3.72-5.27-3.72-5.27Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M242.36,210.55a6,6,0,0,1,6.23,4.8c.27,2-1.57,4.16-5.87,2.23C237.37,215.18,238.53,210.72,242.36,210.55Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M226.74,177.68s1.65-11.89,9.62-20c15.21-15.41,28.14-14.48,28.14-14.48s-.11-2.17-5-3.83c-4.56-1.55-6.62-.72-6.62-.72s-12.52,1-23.07,12.72S218.15,178,218.15,178Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M225.6,176.23c-10-1.69-15.52,6.1-15.93,14S215,204,222.6,203.43C239.77,202.09,237.81,178.3,225.6,176.23Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M220.64,195.79a6.79,6.79,0,0,1-6.12-3.64,7.57,7.57,0,0,1,.29-7.82.37.37,0,1,1,.62.42,6.81,6.81,0,0,0-.25,7,6,6,0,0,0,5.65,3.25,6.54,6.54,0,0,0,5.43-2.93,8.27,8.27,0,0,0,.82-7.35,5.59,5.59,0,0,0-5.58-3.67.37.37,0,0,1-.42-.32.38.38,0,0,1,.32-.42,6.27,6.27,0,0,1,6.39,4.15,9.08,9.08,0,0,1-.9,8,7.33,7.33,0,0,1-6,3.26Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M213.39,228.26s-30.2,7.45-40.75,19.45-15.52,71.17-15.73,82.14,7.45,15.52,12,18.62,24.62,8.69,40.76,9.52,31.45,0,31.45,0a21.54,21.54,0,0,1,2.43-8.69c2.3-4.8,5.22-5.8,5.22-5.8l-13.86-5S232.48,295,228.7,274C224.36,249.78,213.39,228.26,213.39,228.26Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M263.46,331.59a.51.51,0,0,1-.2,0,.5.5,0,0,1-.25-.66c2.83-6.39,5.76-18.92,7.41-27.72l.14-.71c.5-2.59,1.12-5.81-.12-8-.64-1.13-2.07-3.59-3.44-5.95s-2.77-4.77-3.15-5.46c-.73-1.35,1.57-5,4.89-9.91.89-1.34,1.67-2.49,2.12-3.27,1.19-2,.4-3.93-.51-6.1L270,263c-.82-2-1.76-4.06-2.67-6l-1.11-2.42c-.49-1.07-1-2.15-1.47-3.26A188.91,188.91,0,0,0,255,231.52a.51.51,0,0,1,.18-.69.49.49,0,0,1,.68.18,190,190,0,0,1,9.87,19.87l1.47,3.25,1.11,2.41c.91,2,1.85,4,2.69,6.07l.31.74c.93,2.22,1.89,4.51.46,7-.47.81-1.25,2-2.16,3.33-1.73,2.58-5.34,7.95-4.84,8.87.37.68,1.71,3,3.13,5.44s2.82,4.83,3.45,6c1.42,2.54.76,5.95.23,8.7l-.14.7c-.6,3.21-3.79,19.61-7.48,27.94A.5.5,0,0,1,263.46,331.59Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M234,333.35a.47.47,0,0,1-.35-.15c-2.36-2.37-13.69-22-14.54-25.69-.46-2,.7-7.15,1.82-12.11.87-3.84,1.77-7.81,1.52-8.88-.39-1.61-3.29-4-6.09-6.27-3.39-2.77-6.89-5.63-7.57-8.21-.77-2.93-.11-21.26.33-33.39.15-4.37.28-7.81.28-9a.5.5,0,0,1,.5-.5h0a.5.5,0,0,1,.5.5c0,1.24-.13,4.7-.28,9.07-.41,11.34-1.09,30.32-.36,33.11.6,2.26,4.12,5.14,7.23,7.69s6,4.87,6.43,6.8c.31,1.3-.54,5-1.51,9.34-1,4.63-2.23,9.86-1.82,11.67.83,3.61,12,22.88,14.27,25.21a.49.49,0,0,1,0,.7A.47.47,0,0,1,234,333.35Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M193.33,324.76h-.07a.5.5,0,0,1-.43-.57c.37-2.6,6.11-54.4,6.37-58.37a.5.5,0,0,1,1,.07c-.27,4-6,55.84-6.38,58.44A.5.5,0,0,1,193.33,324.76Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M234.5,338.83a.43.43,0,0,1-.19,0c-1.27-.51-6.89-2.41-14-4.81-14.36-4.84-34-11.47-37.77-13.41a.51.51,0,0,1-.21-.68.5.5,0,0,1,.67-.21c3.67,1.91,24.11,8.8,37.62,13.36,7.13,2.4,12.77,4.3,14.07,4.83a.5.5,0,0,1,.27.65A.51.51,0,0,1,234.5,338.83Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M227.59,359.46c-12.63,0-37.13-2.28-55.74-8.86a.5.5,0,0,1,.33-1c23.51,8.32,56.4,9.74,62.52,8.37a.5.5,0,1,1,.22,1A39.61,39.61,0,0,1,227.59,359.46Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M83,235.24c3.92,3.45,8.89,5.66,12.33,9.65,1.36,1.57,2.57,3.24,3.83,4.89.92,1.2,3.36,3.18,3.76,4.69.17.66.13-.24,0-.9l0-.08c-.34-3.05-.59-6.11-.7-9.18s.09-6.13-.1-9.19c-.28-4.3-1.62-8.48-5.14-11.18-1.72-1.31-3.94-2.12-5.52-3.58s-.9-3,0-4.53a15.82,15.82,0,0,0,2.15-4.55,8.06,8.06,0,0,0-1.31-5.47c-2.05-3.44-6.6-7.28-10.9-6.76-3.59.43-4,4.57-3.94,7.45s.32,5.6.35,8.41-.46,5.7-.5,8.57C77.12,228.36,79.37,232.08,83,235.24Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.41,280a46.24,46.24,0,0,1,3.88-7.41c2.12-3.25,4.46-6.42,5.88-10.05s1.24-7.7,1.38-11.61c.11-2.87,1-5.74.73-8.63-.11-1.38-.91-3.61-2.69-3.39-1.4.18-2.22,1.91-2.76,3a52.68,52.68,0,0,0-2.27,6c-.27.79-.53,1.59-.87,2.35-.2.44-.84,1.52-1.43,1.38-1-.26-.1-4.41,0-5.14.76-3.69,1.91-7.12,2.06-10.92.23-5.51-.19-12.07-5.58-15.08-1.41-.79-3.19-1.26-4.53-.08s-1.7,3.18-1.89,4.83c-.6,5.09.59,9.91,2.23,14.69,1.34,4,2.94,8,3.06,12.26.11,4.07-2,7.67-3,11.52a36.51,36.51,0,0,0-1.26,11.35c0,2.48.08,4.94.26,7.42.17,2.28.37,4.55.65,6.82,0,.46.1.94.17,1.42-.88-2.11-1.19-4.52-1.91-6.64-1.29-3.76-2.78-7.45-4-11.23a92.34,92.34,0,0,0-3.33-9.28c-1.27-2.81-2.79-5.79-5.15-7.86a7.56,7.56,0,0,0-5.06-2,13.85,13.85,0,0,0-3.48.74,3.92,3.92,0,0,1-3.75-.66c-3.86-3-5-8.29-7.89-12C76.76,239,71.7,234.23,68,237.28c-2,1.62-2.52,4.76-2.41,7.16a17.33,17.33,0,0,0,3,8.29c1.67,2.68,3.82,5.08,5.36,7.83a8.31,8.31,0,0,1,.9,5,12,12,0,0,0,.3,5.07c1.77,5,7.3,4.31,11.6,4.44a32.22,32.22,0,0,1,9.09,1.51,10.09,10.09,0,0,1,6.63,6.52c.85,2.36,1.31,5,2.92,7.05a7.51,7.51,0,0,0,2.85,2.13c1.68.74,6.79,1.06,6.83.6a22.68,22.68,0,0,1,1.33-4.7C117.26,285.42,118.28,282.71,119.41,280Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M143.14,279.08c-.44-2.87-.36-6-1.72-8.65a.38.38,0,0,0-.52-.14c-1,.54-1,2.11-1.1,3.07-.13,1.6,0,3.2-.23,4.79a36.09,36.09,0,0,1-2,8.31,9,9,0,0,1-6.23,5.6,15.83,15.83,0,0,0-5.44,2.4,11.51,11.51,0,0,0-3.2,4.41c-2,4.51-3,9.54-3.89,14.36-.63,3.24-1.14,6.5-1.93,9.71a94,94,0,0,0-2.08,9.67c-.08.17-.16.33-.23.5-.21.49.56.75.82.35,3.11-4.79,6.9-9.08,12.06-11.71,2.33-1.19,5.43-1.44,7.38-3.31,1.48-1.42,1.68-3.59,1.46-5.53-.29-2.54-1.51-4.63-2.78-6.79-.7-1.19-1.52-2.47-1.24-3.91a5,5,0,0,1,2.53-3.07c2.14-1.33,4.65-1.93,6.41-3.85a10.51,10.51,0,0,0,2.72-6.41A44.23,44.23,0,0,0,143.14,279.08Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100.77,295.59a41.22,41.22,0,0,0-9.77-9c-2-1.32-6.67-3.92-7.62,0-.55,2.28,1.68,4.52,3.15,5.95,2.21,2.15,4.76,4,6.62,6.48-2.3.74-4.71.88-6.72,2.48-2.37,1.89-3.44,5.53-1.08,7.85a15.16,15.16,0,0,0,4.09,2.51c1.86.89,3.75,1.71,5.65,2.5,4.11,1.72,8.27,3.46,11.77,6.27s6.93,7.71,7.21,12.38c0,.45-.14,0,.12-.16.15.13.64-.11.64-.37a49.37,49.37,0,0,0-4.16-19.89A82.64,82.64,0,0,0,100.77,295.59Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M91.3,231c1.52,3.14,3.1,6.2,4.78,9.26a76.17,76.17,0,0,1,4.44,9c1.49,3.87,3,7.68,4.62,11.52a112.27,112.27,0,0,1,4.27,12.2,144.67,144.67,0,0,1,4.83,24.81,100,100,0,0,1,.51,12.83c-.09,3.34-.47,6.65-.78,10a58.73,58.73,0,0,0-.28,10.44c.25,2.9.71,6.35,3,8.42a.52.52,0,0,0,.81-.62c-2.68-5.49-2.53-11.48-2-17.44.29-3.28.68-6.55.79-9.85a98,98,0,0,0-.42-12.59,148.86,148.86,0,0,0-4.54-24.32,108.69,108.69,0,0,0-4-12c-1.55-3.94-3.35-7.78-4.86-11.74-2.73-7.17-6.9-13.52-10.58-20.2-.19-.35-.69,0-.53.31Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M114.37,289.64c.43-5.22.89-10.24,2.65-15.22.82-2.32,1.82-4.58,2.61-6.91.65-1.93,1.63-4.57,1.13-6.62a.23.23,0,0,0-.45,0c-.34,1.17-.3,2.45-.55,3.65a31.25,31.25,0,0,1-.91,3.45c-.77,2.41-1.78,4.72-2.66,7.1A35.19,35.19,0,0,0,114,289.64a.18.18,0,0,0,.36,0Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M84.12,259.65c2.07,5,8.3,5.29,12.84,6.41a12,12,0,0,1,7.35,5.77,43.78,43.78,0,0,1,4.19,10.1s.07,0,.06,0c-1.27-6-3.08-13.22-9.27-16-5-2.24-11.48-1.12-14.65-6.47-.16-.26-.64-.09-.52.22Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M111.09,288.85c.25.33.47.68.73,1a2.43,2.43,0,0,0,.41.44,1,1,0,0,0,.58.29.12.12,0,0,0,.11-.18,2.1,2.1,0,0,0-.44-.4l-.44-.39c-.29-.28-.55-.58-.84-.86,0-.05-.16,0-.11.09Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M98.14,304.73a50.47,50.47,0,0,1,9.49,10.2,62,62,0,0,1,3.45,5.69,62.62,62.62,0,0,1,2.8,6.59c.06.17.37.17.35,0-.5-4.71-3.48-8.74-5.87-12.66a30.41,30.41,0,0,0-4.44-5.37,39.08,39.08,0,0,0-5.46-4.82c-.24-.17-.56.22-.32.42Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M126.59,299.18c-1.72,1-1.77,3.7-1.81,5.43-.06,3.34.76,6.47-.7,9.65-1.32,2.87-3.43,5.27-5.1,7.93-1.55,2.5-3.08,5.69-3,8.69,0,.18.27.27.35.1a36.67,36.67,0,0,0,1.3-4.34,18,18,0,0,1,2.12-4.48c1.6-2.48,3.56-4.73,4.86-7.4s1.16-5.58,1.07-8.62c-.06-1.94-.25-5.06,1.31-6.5.25-.23-.06-.61-.35-.46Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M115.08,331.19C108.15,331.1,95,331,95,331l3.26,24.26a11,11,0,0,0,10.91,9.53h11.93a11,11,0,0,0,10.9-9.53L135.22,331S122,331.1,115.08,331.19Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "417.89 214.75 378.34 293.1 263.03 293.93 298.61 213.65 417.89 214.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M218.8,365.29l0-6.27h74.64l34.35-75.31H447.19l3,2.9H333.57l-35.69,78.62S218.8,365.08,218.8,365.29Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M390.31,329.84c-1.3,3.91-8.37,6.92-15.79,6.74s-12.38-3.5-11.08-7.41,8.38-6.93,15.8-6.74S391.61,325.93,390.31,329.84Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M297.88,365.73a.54.54,0,0,1-.21-.05.5.5,0,0,1-.25-.66l35.82-78.91h117a.5.5,0,0,1,.5.5.51.51,0,0,1-.5.5H333.89l-35.56,78.33A.49.49,0,0,1,297.88,365.73Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 44.13,
    y: 299.37,
    width: 137.17,
    height: 30.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 180.52,
    y: 299.37,
    width: 246.8,
    height: 30.41
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "181.3 299.37 180.52 299.37 44.13 299.37 44.13 304.96 180.52 304.96 181.3 304.96 427.32 304.96 427.32 299.37 181.3 299.37"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 37.51,
    y: 293.37,
    width: 149.79,
    height: 7.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 186.52,
    y: 293.37,
    width: 246.8,
    height: 7.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 92.82,
    y: 98.78,
    width: 59.28,
    height: 35.03,
    rx: 5.43
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "165.9 116.29 147.71 108.62 147.71 123.96 165.9 116.29"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 110.97,
    cy: 116.29,
    r: 3.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 122.46,
    cy: 116.29,
    r: 3.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 133.95,
    cy: 116.29,
    r: 3.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M425.5,96.26H313.7a13,13,0,0,0-13,13v53a13,13,0,0,0,13,13h10c.28,4.8-.41,12-4.43,21.1a56.13,56.13,0,0,0,24.24-21.1h82a13,13,0,0,0,13-13v-53A13,13,0,0,0,425.5,96.26Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M377.81,121.54H322.36a2.77,2.77,0,0,1-2.76-2.76h0a2.77,2.77,0,0,1,2.76-2.76h55.45a2.77,2.77,0,0,1,2.76,2.76h0A2.77,2.77,0,0,1,377.81,121.54Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M417.57,137.61H321.29a1.69,1.69,0,0,1-1.69-1.69h0a1.69,1.69,0,0,1,1.69-1.69h96.28a1.69,1.69,0,0,1,1.69,1.69h0A1.69,1.69,0,0,1,417.57,137.61Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M417.57,147H321.29a1.69,1.69,0,0,1-1.69-1.69h0a1.69,1.69,0,0,1,1.69-1.69h96.28a1.69,1.69,0,0,1,1.69,1.69h0A1.69,1.69,0,0,1,417.57,147Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M396.57,157H321.29a1.69,1.69,0,0,1-1.69-1.69h0a1.69,1.69,0,0,1,1.69-1.69h75.28a1.69,1.69,0,0,1,1.69,1.69h0A1.69,1.69,0,0,1,396.57,157Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M416.81,121.54H390.36a2.77,2.77,0,0,1-2.76-2.76h0a2.77,2.77,0,0,1,2.76-2.76h26.45a2.77,2.77,0,0,1,2.76,2.76h0A2.77,2.77,0,0,1,416.81,121.54Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 285.81,
    y: 147.13,
    width: 34.03,
    height: 24.52,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M335.33,234.91a.78.78,0,0,1-.47-.17l-16.35-13.5a.75.75,0,1,1,1-1.16l15.85,13.1,15.45-13.45a.75.75,0,1,1,1,1.13l-15.93,13.86A.73.73,0,0,1,335.33,234.91Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M319,242.94a.74.74,0,0,1-.54-1.26l11.43-12a.75.75,0,0,1,1.06,0,.75.75,0,0,1,0,1.06l-11.43,12A.7.7,0,0,1,319,242.94Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M351.27,242.5a.75.75,0,0,1-.54-.22l-11.38-11.41a.75.75,0,0,1,0-1.06.74.74,0,0,1,1.06,0l11.39,11.41a.76.76,0,0,1,0,1.07A.73.73,0,0,1,351.27,242.5Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 321.41,
    cy: 146.37,
    r: 10.03
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-25",
    transform: "translate(314.35 150.61)"
  }, "85"), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 359.57,
    y: 125.51,
    width: 66.62,
    height: 17.17,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M400.1,210.45a.77.77,0,0,1-.63-.28.94.94,0,0,1-.22-.7l.26-2.23c0-.05,0-.09,0-.11s-.08,0-.14,0l-1.83,1.32a.85.85,0,0,1-.7.18.86.86,0,0,1-.6-.43.85.85,0,0,1-.09-.79.91.91,0,0,1,.52-.48l2.05-.93c.06,0,.09,0,.09-.08s0-.07-.09-.09l-2.05-.92a.85.85,0,0,1-.51-.54.94.94,0,0,1,.08-.73.91.91,0,0,1,.6-.44,1,1,0,0,1,.7.16l1.83,1.35c.06,0,.1,0,.14,0s0-.06,0-.12l-.26-2.22a.89.89,0,0,1,.23-.7.85.85,0,0,1,.68-.28.84.84,0,0,1,.84,1l-.25,2.22c0,.06,0,.1,0,.12a.15.15,0,0,0,.15,0l1.82-1.32a.93.93,0,0,1,.72-.19.83.83,0,0,1,.58.44.86.86,0,0,1,.1.79,1,1,0,0,1-.52.48l-2.06.92c-.05,0-.08,0-.08.09s0,.06.08.08l2.06.93a.89.89,0,0,1,.52.54.84.84,0,0,1-.1.73.79.79,0,0,1-.58.43.94.94,0,0,1-.72-.15l-1.82-1.35a.15.15,0,0,0-.15,0,.09.09,0,0,0,0,.11l.25,2.23a.8.8,0,0,1-.21.7A.9.9,0,0,1,400.1,210.45Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M412.22,210.45a.78.78,0,0,1-.63-.28.93.93,0,0,1-.21-.7l.25-2.23c0-.05,0-.09,0-.11s-.08,0-.14,0l-1.83,1.32a.84.84,0,0,1-.7.18,1,1,0,0,1-.69-1.22,1,1,0,0,1,.52-.48l2.06-.93c.05,0,.08,0,.08-.08s0-.07-.08-.09l-2.06-.92a.9.9,0,0,1-.51-.54,1,1,0,0,1,.09-.73.91.91,0,0,1,.59-.44.94.94,0,0,1,.7.16l1.83,1.35c.06,0,.11,0,.14,0s0-.06,0-.12l-.25-2.22a.93.93,0,0,1,.22-.7.87.87,0,0,1,.68-.28.83.83,0,0,1,.65.28.81.81,0,0,1,.19.7l-.25,2.22q0,.09,0,.12s.08,0,.14,0l1.83-1.32a.91.91,0,0,1,.72-.19.81.81,0,0,1,.57.44.83.83,0,0,1,.1.79,1,1,0,0,1-.52.48l-2.05.92q-.09,0-.09.09s0,.06.09.08l2.05.93a.87.87,0,0,1,.52.54.81.81,0,0,1-.1.73.78.78,0,0,1-.57.43.92.92,0,0,1-.72-.15L413,207.16c-.06,0-.1,0-.14,0s0,.06,0,.11l.25,2.23a.8.8,0,0,1-.21.7A.9.9,0,0,1,412.22,210.45Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M424.35,210.45a.8.8,0,0,1-.64-.28.93.93,0,0,1-.21-.7l.26-2.23c0-.05,0-.09,0-.11a.13.13,0,0,0-.14,0l-1.83,1.32a.85.85,0,0,1-.7.18.86.86,0,0,1-.6-.43.83.83,0,0,1-.09-.79.91.91,0,0,1,.52-.48l2.05-.93c.06,0,.09,0,.09-.08s0-.07-.09-.09l-2.05-.92a.85.85,0,0,1-.51-.54.94.94,0,0,1,.08-.73.91.91,0,0,1,.6-.44,1,1,0,0,1,.7.16l1.83,1.35a.13.13,0,0,0,.14,0s0-.06,0-.12l-.26-2.22a.89.89,0,0,1,.23-.7.85.85,0,0,1,.67-.28.84.84,0,0,1,.85,1l-.25,2.22c0,.06,0,.1,0,.12a.13.13,0,0,0,.14,0l1.83-1.32a.93.93,0,0,1,.72-.19.83.83,0,0,1,.58.44.86.86,0,0,1,.1.79,1,1,0,0,1-.52.48l-2.06.92c-.05,0-.08,0-.08.09s0,.06.08.08l2.06.93a.89.89,0,0,1,.52.54.84.84,0,0,1-.1.73.79.79,0,0,1-.58.43.94.94,0,0,1-.72-.15l-1.83-1.35a.13.13,0,0,0-.14,0,.09.09,0,0,0,0,.11l.25,2.23a.8.8,0,0,1-.21.7A.9.9,0,0,1,424.35,210.45Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M436.47,210.45a.78.78,0,0,1-.63-.28.93.93,0,0,1-.21-.7l.25-2.23c0-.05,0-.09,0-.11s-.08,0-.14,0l-1.83,1.32a.84.84,0,0,1-.7.18,1,1,0,0,1-.69-1.22A1,1,0,0,1,433,207l2.06-.93c.05,0,.08,0,.08-.08s0-.07-.08-.09l-2.06-.92a.9.9,0,0,1-.51-.54,1,1,0,0,1,.09-.73.91.91,0,0,1,.59-.44.94.94,0,0,1,.7.16l1.83,1.35c.06,0,.11,0,.14,0s0-.06,0-.12l-.25-2.22a.89.89,0,0,1,.22-.7.87.87,0,0,1,.68-.28.83.83,0,0,1,.65.28.81.81,0,0,1,.19.7l-.25,2.22q0,.09,0,.12s.08,0,.14,0l1.83-1.32a.91.91,0,0,1,.72-.19.81.81,0,0,1,.57.44.86.86,0,0,1,.1.79,1,1,0,0,1-.52.48l-2.05.92q-.09,0-.09.09s0,.06.09.08L440,207a.87.87,0,0,1,.52.54.81.81,0,0,1-.1.73.78.78,0,0,1-.57.43.92.92,0,0,1-.72-.15l-1.83-1.35c-.06,0-.1,0-.14,0s0,.06,0,.11l.25,2.23a.8.8,0,0,1-.21.7A.9.9,0,0,1,436.47,210.45Z",
    transform: "translate(-32.3 -71.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M448.6,210.45a.79.79,0,0,1-.64-.28.93.93,0,0,1-.21-.7l.26-2.23c0-.05,0-.09,0-.11a.13.13,0,0,0-.14,0L446,208.48a.92.92,0,0,1-1.4-1,1,1,0,0,1,.53-.48l2.05-.93c.06,0,.08,0,.08-.08s0-.07-.08-.09l-2.05-.92a.85.85,0,0,1-.51-.54.9.9,0,0,1,.08-.73.91.91,0,0,1,.59-.44,1,1,0,0,1,.71.16l1.83,1.35a.13.13,0,0,0,.14,0s0-.06,0-.12l-.26-2.22a.89.89,0,0,1,.23-.7.85.85,0,0,1,.67-.28.84.84,0,0,1,.85,1l-.26,2.22c0,.06,0,.1,0,.12a.13.13,0,0,0,.14,0l1.83-1.32a.93.93,0,0,1,.72-.19.83.83,0,0,1,.58.44.86.86,0,0,1,.1.79,1,1,0,0,1-.53.48l-2.05.92c-.06,0-.08,0-.08.09s0,.06.08.08l2.05.93a.88.88,0,0,1,.53.54.84.84,0,0,1-.1.73.79.79,0,0,1-.58.43.94.94,0,0,1-.72-.15l-1.83-1.35a.13.13,0,0,0-.14,0s0,.06,0,.11l.26,2.23a.8.8,0,0,1-.21.7A.9.9,0,0,1,448.6,210.45Z",
    transform: "translate(-32.3 -71.85)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpB);
export default __webpack_public_path__ + "static/media/help-b.0a95ac95a377059ec8365594c0c41614.svg";
export { ForwardRef as ReactComponent };